/* Cerceve MODEL + RENK secicisi (Claude, 15 Eylul 2026).
 *
 * Kullanici: iki cerceve modeli var - "Basic" (duvardan 1,5 cm) ve "Derin"
 * (duvardan 3,5 cm); ikisinin de siyahi ve beyazi var. Musteri bunu TEK
 * uzun liste ("Siyah, Beyaz, Siyah Derin, Beyaz Derin") olarak degil, iki
 * ayri secim olarak gormeli (daha once "Siyah + paspartu" birlesik listesi
 * begenilmemisti).
 *
 * NEDEN BOYLE: Shopify bir urunde en fazla 3 secenek tasiyor; poster
 * urunlerinde Yon / Boyut / Cerceve dolu. Model ayri secenek olamadigi icin
 * Cerceve DEGERINE gomulu: "Siyah", "Beyaz", "Siyah Derin", "Beyaz Derin"
 * (bkz. poster-bot/derin_cerceve.py). Bu dosya temanin kendi Cerceve
 * dugmelerini GIZLER (DOM'da kalir, sepet ve fiyat onlardan yurur) ve yerine
 * iki grup cizer; tiklaninca asil radyoya tiklar. Temanin fiyat, varyant ve
 * galeri guncellemesi hic degismeden calisir.
 *
 * YALNIZ DERIN DEGERI OLAN URUNLERDE devreye girer; henuz Derin eklenmemis
 * urunlerde hicbir sey yapmaz.
 *
 * Tema varyant degisince secici bolumunu YENIDEN CIZIYOR (galeri-filtre.js'te
 * olculdu); bu yuzden her degisimde bastan kuruluyor (MutationObserver).
 */
(function () {
  var ADI = 'Çerçeve';
  // 16 Eylul 2026: Galeri eklendi (onden 8 cm, duvardan 5 cm, yalniz siyah,
  // kucuk olculerde yok - o olcude dugme pasif gorunur).
  var MODELLER = [
    { anahtar: 'basic', ad: 'Basic', not: 'duvardan 1,5 cm' },
    { anahtar: 'derin', ad: 'Derin', not: 'duvardan 3,5 cm' },
    { anahtar: 'galeri', ad: 'Galeri', not: 'önden 8 cm · duvardan 5 cm' }
  ];
  var MODEL_ADI = { basic: 'Basic', derin: 'Derin', galeri: 'Galeri' };
  var MODEL_EK_UCRET = {
    derin: {
      '12x17': 100, '15x20': 100, '17x23': 100, '20x20': 100,
      '24x33': 150, '30x30': 150, '30x42': 150,
      '35x50': 200, '40x40': 200, '40x50': 200, '50x50': 200, '50x70': 300
    },
    galeri: {
      '30x30': 300, '30x42': 300,
      '35x50': 500, '40x40': 500, '40x50': 500, '50x50': 500, '50x70': 700
    }
  };
  var RENKLER = ['Siyah', 'Beyaz'];
  /* EK RENKLER (19 Eylul 2026). Bunlar VARYANT DEGIL: olculdu, poster basina
     86 varyant var ve Shopify'in siniri 100; bir renk 19 varyant demek, yani
     kirmizi bile sigmiyordu. Fiyati degistirmedikleri icin paspartu gibi
     SATIR OZELLIGI olarak gonderiliyorlar: varyant "Siyah" secili kalir,
     properties[Renk] gercek rengi tasir. Yalniz BASIC'te var - Codex ince
     sablonlari Basic icin uretti. */
  var EK_RENKLER = ['Ceviz', 'Kırmızı', 'Pembe', 'Sarı'];
  var EK_MODEL = 'basic';
  // Nokta renkleri pipeline.FRAME_PALET govde degerleriyle AYNI.
  var RENK_TON = {
    'Siyah': '#121212', 'Beyaz': '#fafaf8', 'Ceviz': '#4b221e',
    'Kırmızı': '#bd0e16', 'Pembe': '#d375ae', 'Sarı': '#f5c707'
  };
  var OZELLIK = 'properties[Renk]';
  /* SECIM BELLEKTE TUTULUYOR (19 Eylul 2026'da tarayicida yakalandi): renk
     dugmesine basinca asil varyant radyosuna tikliyoruz, tema da urun
     formunu YENIDEN CIZIYOR. Forma eklenen gizli alan o anda siliniyor ve
     renk kayboluyordu - Ceviz secilince galeri siyaha donuyordu. Dogru
     kaynak artik bu degisken; her cizimde alana geri yaziliyor. */
  var SECILI_RENK = null;

  function ozellikGirdisi(fs) {
    var form = fs.closest('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
    if (!form) return null;
    var g = form.querySelector('[data-cp-renk-secim]');
    if (!g) {
      g = document.createElement('input');
      g.type = 'hidden';
      g.name = OZELLIK;
      g.setAttribute('data-cp-renk-secim', '');
      form.appendChild(g);
    }
    return g;
  }

  if (!document.getElementById('cp-model-secici-stil')) {
    var stil = document.createElement('style');
    stil.id = 'cp-model-secici-stil';
    stil.textContent =
      '[data-cp-model-gizli]{display:none !important}' +
      '.cp-model-grup{margin:0 0 .5rem;border:0;padding:0}' +
      '.cp-model-grup legend{font-size:.9em;margin-bottom:.45rem;padding:0}' +
      '.cp-model-grup legend b{font-weight:600}' +
      '.cp-model-dugmeler{display:flex;flex-wrap:wrap;gap:.5rem}' +
      '.cp-model-dugme{display:flex;flex-direction:column;align-items:flex-start;gap:.1rem;' +
      'min-width:7.5rem;padding:.55rem .85rem;border:1px solid rgba(0,0,0,.22);' +
      'border-radius:var(--style-border-radius-buttons-primary,.5rem);background:transparent;' +
      'color:inherit;font:inherit;cursor:pointer;text-align:left;line-height:1.2}' +
      '.cp-model-dugme[aria-pressed="true"]{border-color:currentColor;box-shadow:inset 0 0 0 1px currentColor}' +
      '.cp-model-dugme[aria-disabled="true"]{opacity:.45}' +
      '.cp-model-dugme small{font-size:.78em;opacity:.7}' +
      '.cp-model-olcu{font-size:.8em;line-height:1.3;margin:-.2rem 0 .45rem;opacity:.85}' +
      /* DERLI TOPLU (19 Eylul 2026) - EN SONDA olmali, yukaridaki kurallari
         eziyor. Kullanici: secenekler tek ekrana sigmiyor, "Sepete ekle"yi
         gormek icin sayfayi kaydirinca poster gozden kayboluyor. Olculdu:
         695 px ekranda sepet dugmesi 857 px'teydi.
         Renk dugmeleri YALNIZ NOKTA: secili rengin adi zaten baslikta
         ("Renk: Kırmızı") yaziyor, alti renk tek satira sigiyor. */
      '.cp-model-grup{margin:0 0 .35rem}' +
      '.cp-model-grup legend{font-size:.8em;margin-bottom:.22rem}' +
      '.cp-model-dugmeler{gap:.35rem}' +
      '.cp-model-dugme{min-width:0;padding:.26rem .55rem}' +
      '.cp-model-dugme small{font-size:.68em;opacity:.65}' +
      '.cp-renk-dugme{flex-direction:row;align-items:center;gap:.35rem;' +
      'padding:.3rem;width:2rem;height:2rem;justify-content:center;border-radius:50%}' +
      '.cp-renk-dugme span{position:absolute;width:1px;height:1px;overflow:hidden;clip-path:inset(50%)}' +
      '.cp-renk-nokta{width:1.15rem;height:1.15rem;border-radius:50%;flex:0 0 auto;' +
      'border:1px solid rgba(0,0,0,.3)}' +
      '.cp-renk-dugme[aria-pressed="true"]{box-shadow:0 0 0 2px currentColor}' +
      '.variant-option label,.variant-option__button-label{padding:.26rem .55rem !important;' +
      'font-size:.84em !important;min-height:0 !important}' +
      '.variant-option{margin-bottom:.35rem !important}' +
      '.cp-paspartu{margin:.4rem 0 !important;padding:.42rem .65rem !important}' +
      '.cp-paspartu__not{font-size:.78em}';
    stil.textContent += ".cp-model-grup:has(.cp-frame-card){margin:0 0 .65rem}\n.cp-model-grup:has(.cp-frame-card) legend{font-size:.8rem;margin-bottom:.45rem}\n.cp-model-dugmeler:has(.cp-frame-card){display:grid;grid-template-columns:repeat(3,minmax(0,1fr));gap:8px;max-width:354px}\n.cp-model-dugme.cp-frame-card{position:relative;display:flex;align-items:center;justify-content:flex-start;gap:0;width:100%;min-width:0;padding:5px 5px 8px;border:1px solid #ded9d0;border-radius:10px;background:#fffdf9;box-shadow:none;color:#2c2824;text-align:center;transition:border-color .15s,background .15s;overflow:hidden}\n.cp-frame-card .cp-frame-preview{display:block;width:76px;height:46px;max-width:100%;margin:0 0 3px;pointer-events:none}\n.cp-frame-card .cp-frame-name{font-size:12px;font-weight:600;line-height:1.25;letter-spacing:.01em}\n.cp-frame-card .cp-frame-note{font-size:9px;line-height:1.4;opacity:1;color:#79736c;margin-top:2px;white-space:nowrap}\n.cp-frame-card .cp-frame-price{display:block;margin-top:3px;color:#a84f3d;font-size:10px;font-weight:700;line-height:1.2;white-space:nowrap}\n.cp-model-dugme.cp-frame-card[aria-pressed=\"true\"]{border-color:#302c27;box-shadow:inset 0 0 0 1px #302c27;background:#f3eee5}\n.cp-frame-card[aria-pressed=\"true\"]:after{content:'✓';position:absolute;right:5px;top:5px;width:14px;height:14px;border-radius:50%;background:#302c27;color:white;font:10px/14px Arial,sans-serif;text-align:center}\n.cp-model-dugme.cp-frame-card[aria-disabled=\"true\"]{opacity:.5;cursor:not-allowed}\n.cp-model-dugme.cp-frame-card:focus-visible{outline:2px solid #302c27;outline-offset:3px}\n@media(hover:hover){.cp-model-dugme.cp-frame-card:not([aria-disabled=\"true\"]):hover{border-color:#777065;background:#f6f2eb}}\n@media(max-width:360px){.cp-model-dugmeler:has(.cp-frame-card){gap:6px}.cp-frame-card .cp-frame-note{font-size:8px}}\n.cp-model-dugmeler:has(.cp-renk-dugme){display:flex;flex-wrap:wrap;gap:4px;max-width:354px}\n.cp-model-dugme.cp-renk-dugme{width:calc((100% - 20px)/6);max-width:56px;height:57px;min-width:0;flex:0 0 auto;flex-direction:column;align-items:center;justify-content:center;gap:5px;padding:5px 3px;border:1px solid #ded9d0;border-radius:8px;background:#fffdf9;color:#2c2824;box-shadow:none;transition:border-color .15s,background .15s}\n.cp-model-dugme.cp-renk-dugme span{position:static;width:auto;height:auto;overflow:visible;clip-path:none;font-size:10px;font-weight:500;line-height:1;white-space:nowrap}\n.cp-renk-dugme .cp-renk-nokta{width:25px;height:25px;border:1px solid rgba(0,0,0,.18);border-radius:50%;flex:0 0 25px;box-shadow:inset 0 0 0 2px rgba(255,255,255,.12)}\n.cp-model-dugme.cp-renk-dugme[aria-pressed=\"true\"]{background:#f3eee5;border-color:#302c27;box-shadow:inset 0 0 0 1px #302c27}\n.cp-model-dugme.cp-renk-dugme:focus-visible{outline:2px solid #302c27;outline-offset:2px}\n@media(hover:hover){.cp-model-dugme.cp-renk-dugme:not([aria-disabled=\"true\"]):hover{background:#f6f2eb;border-color:#777065}}\n@media(max-width:360px){.cp-model-dugme.cp-renk-dugme{padding:5px 2px;gap:5px}.cp-model-dugme.cp-renk-dugme span{font-size:9px}}\n/* Keep the native radios and option values; only their presentation changes. */\nvariant-picker fieldset:has(input[data-option-name=\"Yön\"]),variant-picker fieldset:has(input[data-option-name=\"Boyut\"]){display:grid;gap:6px;max-width:354px;border:0;padding:0;margin:0 0 12px!important}\nvariant-picker fieldset:has(input[data-option-name=\"Yön\"]){grid-template-columns:repeat(3,minmax(0,1fr))}\nvariant-picker fieldset:has(input[data-option-name=\"Boyut\"]){grid-template-columns:repeat(4,minmax(0,1fr))}\nvariant-picker fieldset:has(input[data-option-name=\"Yön\"]) legend,variant-picker fieldset:has(input[data-option-name=\"Boyut\"]) legend{font-size:12px;margin:0 0 6px;padding:0;color:#4c463f}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]),variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]){display:flex;align-items:center;justify-content:center;gap:8px;width:auto;min-width:0;min-height:34px!important;margin:0;padding:7px 5px!important;border:1px solid #ded9d0!important;border-radius:8px!important;background:#fffdf9!important;color:#2c2824!important;box-shadow:none;transition:background .15s,border-color .15s;overflow:visible}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]){min-height:40px!important}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]) .variant-option__button-label__pill,variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]) .variant-option__button-label__pill{display:none!important}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]) .variant-option__button-label__text,variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]) .variant-option__button-label__text{font-size:11px;font-weight:500;line-height:1.2;color:inherit!important;white-space:nowrap}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]) .variant-option__button-label__text::after{content:' cm';font-size:8px;font-weight:400;color:#857d72}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"])::before{content:'';position:static;display:block;flex:0 0 auto;width:12px;height:17px;border:1.5px solid #80786d;border-radius:2px;background:#f3eee5;box-shadow:inset 0 0 0 2px #fffdf9;transform:none;opacity:1}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"][value=\"Yatay\"])::before{width:19px;height:12px}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"][value=\"Kare\"])::before{width:15px;height:15px}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]:checked),variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]:checked){background:#f3eee5!important;border-color:#302c27!important;box-shadow:inset 0 0 0 1px #302c27}\nvariant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]:focus-visible),variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]:focus-visible){outline:2px solid #302c27;outline-offset:2px}\n@media(hover:hover){variant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]):hover,variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]):hover{border-color:#777065!important;background:#f6f2eb!important}}\n/* Mobile configuration: retain readable labels while reducing vertical travel. */\n.cp-mobile-preview{display:none}\n@media(max-width:749px){\n  .cp-mobile-preview:not([hidden]){position:sticky;z-index:8;display:flex;align-items:center;gap:10px;width:100%;height:68px;min-height:68px;flex:none;padding:4px 8px;border:1px solid #ded9d0;border-radius:9px;background:#fffdf9;box-shadow:0 3px 10px #302c2710;text-align:left;color:#302c27;cursor:pointer}\n  .cp-mobile-preview img{width:58px;height:58px;object-fit:contain;border-radius:4px;background:white;flex:none}\n  .cp-mobile-preview span{display:flex;flex-direction:column;gap:3px}\n  .cp-mobile-preview small{font-size:8px;letter-spacing:.1em;color:#82796e}\n  .cp-mobile-preview strong{font-size:12px;font-weight:600}\n  .cp-mobile-preview em{font-size:9px;font-style:normal;color:#82796e}\n  .group-block-content:has(>variant-picker){gap:10px!important}\n  variant-picker fieldset:has(input[data-option-name=\"Yön\"]),variant-picker fieldset:has(input[data-option-name=\"Boyut\"]){gap:4px;margin-bottom:7px!important}\n  variant-picker fieldset:has(input[data-option-name=\"Yön\"]) legend,variant-picker fieldset:has(input[data-option-name=\"Boyut\"]) legend{font-size:11px;margin-bottom:4px}\n  variant-picker .variant-option__button-label:has(input[data-option-name=\"Yön\"]),variant-picker .variant-option__button-label:has(input[data-option-name=\"Boyut\"]){min-height:29px!important;padding:5px 4px!important}\n  .cp-model-grup:has(.cp-frame-card){margin-bottom:6px}\n  .cp-model-grup:has(.cp-frame-card) legend,.cp-model-grup legend{font-size:11px;margin-bottom:4px}\n  .cp-model-dugme.cp-frame-card{padding:3px 4px 5px;border-radius:8px}\n  .cp-frame-card .cp-frame-preview{height:30px;width:54px;margin-bottom:2px}\n  .cp-frame-card .cp-frame-name{font-size:11px}\n  .cp-frame-card .cp-frame-note{display:none}\n  .cp-frame-card .cp-frame-price{font-size:9px;margin-top:2px}\n  .cp-model-dugme.cp-renk-dugme{height:47px;gap:3px;padding:4px 2px}\n  .cp-renk-dugme .cp-renk-nokta{width:21px;height:21px;flex-basis:21px}\n  .cp-model-dugme.cp-renk-dugme span{font-size:9px}\n  .cp-paspartu{margin:3px 0!important}\n}\n";
    document.head.appendChild(stil);
  }

  // Small vector previews stay sharp on mobile without another image request.
  function modelOnizleme(model) {
    var id = 'cp-frame-' + model;
    var derin = model === 'derin';
    var galeri = model === 'galeri';
    var svg = '<svg class="cp-frame-preview" viewBox="0 0 100 66" aria-hidden="true" focusable="false">' +
      '<defs><linearGradient id="' + id + '-front" x1="0" y1="0" x2="1" y2="1"><stop stop-color="#55524e"/><stop offset=".45" stop-color="#262523"/><stop offset="1" stop-color="#121211"/></linearGradient>' +
      '<linearGradient id="' + id + '-side"><stop stop-color="#3c3935"/><stop offset="1" stop-color="#171614"/></linearGradient></defs>';
    if (galeri) {
      // Broad, stepped front profile; the inner opening remains visibly inset.
      svg += '<path d="M13 9H90V32H37V63H13Z" fill="#d8d2c8" transform="translate(2 2)"/>' +
        '<path d="M12 6H88V29H35V61H12Z" fill="url(#' + id + '-front)"/>' +
        '<path d="M14 59V8H86" fill="none" stroke="#77716a" stroke-width="1.6"/>' +
        '<path d="M19 61V13H88" fill="none" stroke="#171614" stroke-width="4"/>' +
        '<path d="M23 61V17H88" fill="none" stroke="#5f5b55" stroke-width="2.5"/>' +
        '<path d="M28 61V22H88" fill="none" stroke="#141311" stroke-width="4"/>' +
        '<path d="M33 61V27H88" fill="none" stroke="#655f56" stroke-width="1.3"/>' +
        '<path d="M12 6L35 29" stroke="#100f0e" stroke-width=".6" opacity=".6"/>';
    } else {
      var alt = derin ? 62 : 53;
      svg += '<path d="M10 16L50 42L90 16V' + (alt-25) + 'L50 ' + alt + 'L10 ' + (alt-25) + 'Z" fill="#d8d2c8" transform="translate(1 2)"/>' +
        '<path d="M10 16L50 42V' + alt + 'L10 ' + (alt-25) + 'Z" fill="url(#' + id + '-side)"/>' +
        '<path d="M50 42L90 16V' + (alt-25) + 'L50 ' + alt + 'Z" fill="#191816"/>' +
        '<path d="M10 7L50 32L90 7V16L50 42L10 16Z" fill="url(#' + id + '-front)"/>' +
        '<path d="M10 7L50 32L90 7" fill="none" stroke="#77726a" stroke-width=".8"/>' +
        '<path d="M50 32V42" stroke="#12110f" stroke-width=".8"/>' +
        '<path d="M50 43V' + (alt-1) + '" stroke="#4d4841" stroke-width=".6"/>';
    }
    return svg + '</svg>';
  }

  function modelOf(deger) {
    if (/ Derin$/.test(deger)) return 'derin';
    if (/ Galeri$/.test(deger)) return 'galeri';
    return 'basic';
  }
  function renkOf(deger) { return deger.replace(/ (Derin|Galeri)$/, ''); }
  function degerOf(model, renk) {
    return renk + (model === 'basic' ? '' : ' ' + MODEL_ADI[model]);
  }

  function kur() {
    try { kurIc(); } catch (e) {
      // HATA OLURSA tema listesini geri ac (musteri secim yapabilsin)
      var gizliler = document.querySelectorAll('[data-cp-model-gizli]');
      for (var i = 0; i < gizliler.length; i++) gizliler[i].removeAttribute('data-cp-model-gizli');
      if (window.console) console.error('cp-model-secici:', e);
    }
  }

  function kurIc() {
    var girdiler = document.querySelectorAll('input[type="radio"][data-option-name="' + ADI + '"]');
    if (!girdiler.length) return;

    // Ayni sayfada birden fazla secici olabilir (ornegin yapiskan sepet cubugu);
    // her fieldset ayri kurulur.
    var kumeler = new Map();
    girdiler.forEach(function (g) {
      var fs = g.closest('fieldset') || g.parentElement;
      if (!kumeler.has(fs)) kumeler.set(fs, []);
      kumeler.get(fs).push(g);
    });

    kumeler.forEach(function (liste, fs) {
      var degerler = liste.map(function (g) { return g.value; });
      var derinVar = degerler.some(function (d) { return / (Derin|Galeri)$/.test(d); });
      var onceki = fs.previousElementSibling;
      if (!derinVar) {
        // Derin'i olmayan urun: dokunma, eski kurulum varsa kaldir.
        if (onceki && onceki.hasAttribute('data-cp-model-kap')) onceki.remove();
        fs.removeAttribute('data-cp-model-gizli');
        return;
      }

      var secili = liste.find(function (g) { return g.checked; }) || liste[0];
      var aktifModel = modelOf(secili.value);
      var aktifRenk = renkOf(secili.value);

      var kap = (onceki && onceki.hasAttribute('data-cp-model-kap')) ? onceki : null;
      if (!kap) {
        kap = document.createElement('div');
        kap.setAttribute('data-cp-model-kap', '');
        fs.parentNode.insertBefore(kap, fs);
      }

      var ozGirdi = ozellikGirdisi(fs);
      // EK RENK SECILIYSE onu geri yaz: varyant "Siyah" kalir, gercek renk
      // ozellikte durur. Model Basic disina cikarsa ek renk dusurulur.
      if (!SECILI_RENK && window.__cpRenk) SECILI_RENK = window.__cpRenk;
      if (SECILI_RENK && EK_RENKLER.indexOf(SECILI_RENK) !== -1 && aktifModel === EK_MODEL) {
        aktifRenk = SECILI_RENK;
        if (ozGirdi) ozGirdi.value = SECILI_RENK;
      } else {
        if (EK_RENKLER.indexOf(SECILI_RENK) !== -1) SECILI_RENK = aktifRenk;
        if (ozGirdi) ozGirdi.value = aktifRenk;
      }

      function girdiBul(model, renk) {
        // RADYO HER SEFERINDE SAYFADAN TAZE ARANIYOR (21 Eylul 2026'da
        // tarayicida olculdu). Tema varyant degisince secici bolumunu yeniden
        // ciziyor ve radyolar YENI dugumlerle degisiyor; `liste` ilk kurulumda
        // yakalanan ESKI (sayfadan kopmus) radyolari tutuyordu. Ilk tiklama
        // calisiyor, sonrakiler kopuk radyoya tikliyor ve hicbir sey olmuyordu.
        var hedef = degerOf(model, renk);
        var canli = fs.isConnected ? fs : document;
        var bulunan = canli.querySelector('input[type="radio"][data-option-name="' + ADI +
                                          '"][value="' + hedef.replace(/"/g, '\\"') + '"]');
        if (!bulunan) {
          bulunan = document.querySelector('input[type="radio"][data-option-name="' + ADI +
                                           '"][value="' + hedef.replace(/"/g, '\\"') + '"]');
        }
        return bulunan || liste.find(function (g) { return g.value === hedef; });
      }
      function sec(model, renk) {
        var g = girdiBul(model, model === EK_MODEL && EK_RENKLER.indexOf(renk) !== -1 ? 'Siyah' : renk);
        // Istenen renk bu modelde yoksa ayni modelin ilk rengine dus.
        if (!g) g = RENKLER.map(function (r) { return girdiBul(model, r); }).filter(Boolean)[0];
        if (g) {
          var gercekRenk = renkOf(g.value);
          if (model !== EK_MODEL || EK_RENKLER.indexOf(renk) === -1) {
            SECILI_RENK = gercekRenk;
            window.__cpRenk = gercekRenk;
          }
          if (ozGirdi) ozGirdi.value = SECILI_RENK || gercekRenk;
          if (!g.checked) g.click();
          document.dispatchEvent(new CustomEvent('cp:selection-change'));
          planla();
        }
      }

      function seciliBoyutAnahtari() {
        var alan = fs.closest('variant-picker') || document;
        var input = alan.querySelector('input[type="radio"][data-option-name="Boyut"]:checked');
        var match = input && String(input.value).match(/(\d+)\s*[x×*]\s*(\d+)/i);
        if (!match) return '';
        var a = Number(match[1]);
        var b = Number(match[2]);
        return Math.min(a, b) + 'x' + Math.max(a, b);
      }

      function modelFiyatMetni(model) {
        if (model === 'basic') return 'Fiyata dahil';
        var ek = MODEL_EK_UCRET[model] && MODEL_EK_UCRET[model][seciliBoyutAnahtari()];
        return ek ? '+' + ek.toLocaleString('tr-TR') + ' TL' : 'Bu ölçüde yok';
      }

      var html = '';
      html += '<fieldset class="cp-model-grup"><legend>Çerçeve modeli: <b>' +
        MODEL_ADI[aktifModel] + '</b></legend><div class="cp-model-dugmeler">';
      MODELLER.forEach(function (m) {
        var mevcut = RENKLER.some(function (r) { return girdiBul(m.anahtar, r); });
        if (!mevcut) return;
        // Secili olcude bu modelin satilabilir bir rengi var mi? (Galeri kucuk olculerde yok)
        var satilir = RENKLER.some(function (r) {
          var g = girdiBul(m.anahtar, r);
          return g && g.getAttribute('aria-disabled') !== 'true' && g.getAttribute('data-option-available') !== 'false';
        });
        html += '<button type="button" class="cp-model-dugme cp-frame-card" data-cp-model="' + m.anahtar + '" aria-pressed="' +
          (m.anahtar === aktifModel) + '"' + (satilir || m.anahtar === aktifModel ? '' : ' aria-disabled="true"') +
          '>' + modelOnizleme(m.anahtar) + '<span class="cp-frame-name">' + m.ad + '</span><small class="cp-frame-note">' + (satilir ? ({basic: '1,5 cm derinlik', derin: '3,5 cm derinlik', galeri: '8 cm ön genişlik'}[m.anahtar]) : 'Bu ölçüde yok') + '</small><strong class="cp-frame-price">' + (satilir ? modelFiyatMetni(m.anahtar) : 'Bu ölçüde yok') + '</strong></button>';
      });
      html += '</div></fieldset>';
      /* OLCU KURALI HER MODELDE (kullanici, 23 Eylul 2026: "sadece galeri
         cercevede olcu poster olcusu sayiliyordu, artik hepsinde olcu poster
         olcusudur diye yazalim"). Secilen olcu POSTERIN olcusu; cerceve her
         kenara kendi serit genisligini ekler: Basic 1,5 / Derin 2 / Galeri 8 cm.
         Dis olcu de yazilir ki musteri duvarda kaplayacagi alani gorsun. */
      var SERIT = { basic: 1.5, derin: 2, galeri: 8 };
      var serit = SERIT[aktifModel];
      if (serit) {
        var boyutGirdi = document.querySelector('input[type="radio"][data-option-name="Boyut"]:checked');
        var eslesme = boyutGirdi && String(boyutGirdi.value).match(/(\d+)\s*x\s*(\d+)/i);
        if (eslesme) {
          var yaz = function (n) { return String(Math.round(n * 10) / 10).replace('.', ','); };
          html += '<p class="cp-model-olcu">Seçtiğin ölçü <b>posterin ölçüsüdür</b>; çerçeve her kenara ' +
            yaz(serit) + ' cm ekler. Çerçeveyle dış ölçü: <b>' +
            yaz(Number(eslesme[1]) + serit * 2) + '×' + yaz(Number(eslesme[2]) + serit * 2) + ' cm</b></p>';
        }
      }
      html += '<fieldset class="cp-model-grup"><legend>Renk: <b>' + aktifRenk + '</b></legend><div class="cp-model-dugmeler">';
      RENKLER.forEach(function (r) {
        var g = girdiBul(aktifModel, r);
        if (!g) return;
        var yok = g.getAttribute('aria-disabled') === 'true';
        html += '<button type="button" class="cp-model-dugme cp-renk-dugme" data-cp-renk="' + r + '" aria-pressed="' +
          (r === aktifRenk) + '" ' + (yok ? ' aria-disabled="true"' : '') + '><i class="cp-renk-nokta" style="background:' +
          (RENK_TON[r] || '#888') + '"></i><span>' + r + '</span></button>';
      });
      if (aktifModel === EK_MODEL) {
        EK_RENKLER.forEach(function (r) {
          html += '<button type="button" class="cp-model-dugme cp-renk-dugme" data-cp-renk="' + r + '" aria-pressed="' +
            (r === aktifRenk) + '"><i class="cp-renk-nokta" style="background:' +
            (RENK_TON[r] || '#888') + '"></i><span>' + r + '</span></button>';
        });
      }
      html += '</div></fieldset>';
      // Compare generated markup with itself: innerHTML normalizes attributes
      // and whitespace, which previously rebuilt every button every 60 ms.
      if (kap.__cpMarkup !== html || !kap.querySelector('.cp-model-dugme')) {
        kap.innerHTML = html;
        kap.__cpMarkup = html;
      }
      // TEMANIN KENDI LISTESI ANCAK BIZIM DUGMELER CIZILDIKTEN SONRA
      // GIZLENIR (21 Eylul 2026). Onceden ilk is olarak gizleniyordu; araya
      // bir hata girerse musteri NE bizim dugmeleri NE temanin listesini
      // goruyordu, yani hicbir cerceve secilemiyordu. Kullanici bunu canli
      // sitede yasadi. Artik cizim basarisizsa tema listesi ACIK kaliyor.
      if (kap.querySelector('.cp-model-dugme')) {
        fs.setAttribute('data-cp-model-gizli', '');
      } else {
        fs.removeAttribute('data-cp-model-gizli');
      }

      kap.onclick = function (e) {
        var b = e.target.closest('.cp-model-dugme');
        if (!b) return;
        if (b.getAttribute('aria-disabled') === 'true') return;   // bu olcude olmayan model
        if (b.hasAttribute('data-cp-model')) sec(b.getAttribute('data-cp-model'), aktifRenk);
        else if (b.hasAttribute('data-cp-renk')) {
          var r = b.getAttribute('data-cp-renk');
          SECILI_RENK = r;
          /* Pencerede de duruyor: galeri-filtre.js bunu okuyor. Gizli alan
             tema formu yeniden cizince siliniyor, pencere degiskeni kalir. */
          window.__cpRenk = r;
          if (ozGirdi) {
            ozGirdi.value = r;
            /* OLAY YAYMAK SART (19 Eylul 2026'da tarayicida olculdu):
               galeri-filtre.js 'click'i YAKALAMA evresinde dinliyor, yani
               bu islevden ONCE calisiyor ve eski rengi okuyor. Varyanti
               degistiren renklerde tema kendi 'change'ini yayiyordu ve
               filtre ikinci kez calisiyordu; ek renkte varyant AYNI kaldigi
               icin hicbir olay yoktu ve Ceviz secilince galeri siyah
               kaliyordu. */
            document.dispatchEvent(new CustomEvent('cp:selection-change'));
          }
          /* Tema bolumu yeniden ciziyor; cizim bitince filtreyi TEKRAR
             tetikle, yoksa galeri eski renkte kaliyor (olculdu). */
          
          // Ek renkte varyant Siyah kalir (fiyat ayni); Siyah/Beyaz'da
          // varyant gercekten degisir, yoksa sepete yanlis satir gider.
          sec(aktifModel, r);
          if (EK_RENKLER.indexOf(r) !== -1) { aktifRenk = r; planla(); }
        }
      };
    });
  }

  var bekleyen = false;
  function planla() {
    if (bekleyen) return;
    bekleyen = true;
    queueMicrotask(function () { bekleyen = false; kur(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', kur);
  else kur();
  document.addEventListener('change', planla, true);
  new MutationObserver(planla).observe(document.body, { childList: true, subtree: true });
})();

/* Hızlı ürün penceresi, Horizon tarafından sonradan DOM'a ekleniyor ve
 * Boyut seçeneğinde bütün yönlere ait değerleri (geçersizleri üstü çizili)
 * göstermeye devam ediyor. Ürün sayfasındaki gibi yalnız seçilen yöne uyan
 * ölçüleri göster. Bu filtre her variant-picker için ve sonradan açılan
 * quick-add pencerelerinde de çalışır. */
(function () {
  if (window.__cpYonBoyutFiltresi) return;
  window.__cpYonBoyutFiltresi = true;

  if (!document.getElementById('cp-yon-boyut-filtre-stil')) {
    var style = document.createElement('style');
    style.id = 'cp-yon-boyut-filtre-stil';
    style.textContent = '[data-cp-yon-uyumsuz]{display:none!important}';
    document.head.appendChild(style);
  }

  function oranTipi(value) {
    var match = String(value || '').match(/(\d+(?:[.,]\d+)?)\s*[x×*]\s*(\d+(?:[.,]\d+)?)/i);
    if (!match) return null;
    var en = Number(match[1].replace(',', '.'));
    var boy = Number(match[2].replace(',', '.'));
    if (en === boy) return 'Kare';
    return en > boy ? 'Yatay' : 'Dikey';
  }

  function filtrele(picker) {
    var yon = picker.querySelector('input[type="radio"][data-option-name="Yön"]:checked');
    if (!yon) return;
    var boyutlar = Array.from(picker.querySelectorAll('input[type="radio"][data-option-name="Boyut"]'));
    if (!boyutlar.length) return;

    boyutlar.forEach(function (input) {
      var label = input.closest('label') || input.parentElement;
      if (!label) return;
      var tip = oranTipi(input.value);
      var uyumsuz = tip && tip !== yon.value;
      label.toggleAttribute('data-cp-yon-uyumsuz', !!uyumsuz);
    });
  }

  var queued = false;
  function planla() {
    if (queued) return;
    queued = true;
    queueMicrotask(function () {
      queued = false;
      document.querySelectorAll('variant-picker').forEach(filtrele);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', planla);
  else planla();
  document.addEventListener('change', planla, true);
  new MutationObserver(planla).observe(document.body, { childList: true, subtree: true });
})();

(function () {
  if (window.__cpMobilePreview) return;
  window.__cpMobilePreview = true;
  var queued = false;
  function update() {
    queued = false;
    var picker = document.querySelector('main variant-picker');
    if (!picker || !picker.querySelector('[data-cp-model-kap]')) return;
    var section = picker.closest('[id^="shopify-section"]');
    var gallery = section && section.querySelector('media-gallery');
    if (!gallery) return;
    var preview = picker.parentElement.querySelector('.cp-mobile-preview');
    if (!preview) {
      preview = document.createElement('button');
      preview.type = 'button';
      preview.className = 'cp-mobile-preview';
      preview.hidden = true;
      preview.setAttribute('aria-label', 'Ürün görseline dön');
      preview.innerHTML = '<img alt="Seçtiğin çerçevenin önizlemesi"><span><small>SEÇİMİN</small><strong></strong><em>Görsele dön ↗</em></span>';
      preview.addEventListener('click', function () {
        var current = picker.closest('[id^="shopify-section"]')?.querySelector('media-gallery');
        if (current) current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
      picker.before(preview);
    }
    var header = document.querySelector('header-component');
    var top = Math.max(0, Math.min(90, header ? header.getBoundingClientRect().bottom : 0));
    var bounds = picker.getBoundingClientRect();
    var show = window.matchMedia('(max-width:749px)').matches && gallery.getBoundingClientRect().bottom < top + 50 && bounds.bottom > top + 80 && bounds.top < window.innerHeight;
    if (!show) { preview.hidden = true; return; }
    var image = gallery.querySelector('ul.media-gallery__grid>li:not([data-cp-gizli]) img') || gallery.querySelector('slideshow-slide:not([data-cp-gizli]) img');
    if (!image) { preview.hidden = true; return; }
    var src = image.currentSrc || image.src;
    var thumb = preview.querySelector('img');
    if (thumb.src !== src) thumb.src = src;
    var model = picker.querySelector('[data-cp-model][aria-pressed="true"] .cp-frame-name')?.textContent || '';
    var color = picker.querySelector('[data-cp-renk][aria-pressed="true"] span')?.textContent || '';
    var text = [model,color].filter(Boolean).join(' · ');
    var title = preview.querySelector('strong');
    if (title.textContent !== text) title.textContent = text;
    preview.style.top = top + 'px';
    preview.hidden = false;
  }
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(update);
  }
  document.addEventListener('scroll', schedule, { passive:true });
  window.addEventListener('resize', schedule, { passive:true });
  document.addEventListener('change', schedule, true);
  document.addEventListener('cp:selection-change', schedule);
  new MutationObserver(schedule).observe(document.body, {childList:true,subtree:true});
  schedule();
})();
